import { render, staticRenderFns } from "./LjblList.vue?vue&type=template&id=23aa5c90&scoped=true"
import script from "./LjblList.vue?vue&type=script&lang=js"
export * from "./LjblList.vue?vue&type=script&lang=js"
import style0 from "./LjblList.vue?vue&type=style&index=0&id=23aa5c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23aa5c90",
  null
  
)

export default component.exports